import { render, staticRenderFns } from "./OpportunityStatusLabel.vue?vue&type=template&id=61a41eb3&"
import script from "./OpportunityStatusLabel.vue?vue&type=script&lang=js&"
export * from "./OpportunityStatusLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports